export const ELEMENT_LABELS = {
  ownership: 'Ownership',
  management_control: 'Management Control',
  management_control_transport: 'Management Control (Transport)',
  employment_equity: 'Employment Equity',
  skills_development: 'Skills Development',
  skills_development_transport: 'Skills Development (Transport)',
  skills_development_specialised: 'Skills Development Specialised',
  procurement: 'Preferential Procurement',
  enterprise_supplier_development: 'Enterprise and Supplier Development',
  enterprise_development: 'Enterprise Development',
  enterprise_development_transport: 'Enterprise Development (Transport)',
  supplier_development: 'Supplier Development',
  sed: 'Socio-Economic Development',
  sed_transport: 'Socio-Economic Development (Transport)',
  finance_statutory: 'Finance and Statutory',
};
